<template>
  <div>
    <div class="main-wrapper">
      <nav class="navbar navbar-expand-lg main-navbar left-header">
        <a class="header-brand" href="./">
          <img src="/static/img/brand/logo-white.png" class="header-brand-img main-logo" alt="Painel de Pedidos">
        </a>
        <div class="form-inline mr-auto">
          <h4 style="color: #ffffff; margin-top: 5px">Painel de Pedidos APP</h4>
          <h4 style="color: #ffffff; margin-top: 5px; margin-left: 5px;" v-if="local !== null">- {{ local }}</h4>
        </div>
        <ul class="navbar-nav navbar-right">
          <li v-show="loading">
            <i class="fa fa-spinner fa-spin fa-2x mt-2 text-white"></i>
          </li>
          <li class="dropdown dropdown-list-toggle header-fullscreen">
            <a href="#" class="nav-link nav-link-lg full-screen-link" id="fullscreen-button">
              <i class="fe fe-maximize"></i>
            </a>
          </li>
          <li>
            <a href="#" class="navresponsive-toggler d-sm-none nav-link  nav-link-lg d-flex"
               data-toggle="collapse" data-target="#navbarSupportedContent-4"
               aria-controls="navbarSupportedContent-4" aria-expanded="false" aria-label="Toggle navigation">
              <i class="navbar-toggler-icon fe fe-more-vertical text-white"></i>
            </a>
          </li>
        </ul>
      </nav>

      <div class="mb-1 responsive-navbar navbar-dark d-sm-none bg-white">
        <div class="collapse navbar-collapse" id="navbarSupportedContent-4">
          <ul class="navbar-nav navbar-right">
            <li v-show="loading">
              <i class="fa fa-spinner fa-spin fa-2x mt-2 text-white"></i>
            </li>
            <li class="dropdown header-fullscreen">
              <a href="#" class="nav-link nav-link-lg full-screen-link" id="fullscreen-button2">
                <i class="fe fe-maximize"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="app-content">
        <section class="section">
          <div class="row">
            <div class="col-sm-6 col-lg-6 col-xl-3" v-for="count in counts">
              <card-count :classes="count.classes" :icon="count.icon" :label="count.label" :total="count.total" :description="count.description" />
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 col-lg-6 col-xl-2" v-for="order in orders" :class="order.containerClass">
              <card-order :title="order.pedido[0].num_pedido"
                          :client="order.pedido[0].cliente"
                          :datetime="`${order.pedido[0].data_pedido} - ${order.pedido[0].hora_pedido}`"
                          :status="order.status !== null && order.status.length > 0 ? order.status[0].descricao : '---'"
                          :deliveryType="order.pedido[0].entrega || '---'"
                          :paymentMethod="order.pedido[0].pagamento || '---'"
                          :local="order.pedido[0].nome_loja || '---'"
                          :quantity="order.pedido[0].pagamento || 0"
                          :shipping="currency((order.pedido[0].frete || 0), '', 2, {thousandsSeparator: '.', decimalSeparator: ','})"
                          :total="currency((order.pedido[0].total || 0), '', 2, {thousandsSeparator: '.', decimalSeparator: ','})"
                          :totalplus="currency((order.pedido[0].totalplus || 0), '', 2, {thousandsSeparator: '.', decimalSeparator: ','})"
                          :pulse="order.pulse"
                          :classes="order.classes"
                          :initClasses="'tremerumavez'" />
            </div>
          </div>
        </section>
      </div>

      <!--        <div class="sidebar sidebar-right sidebar-animate">-->
      <!--            <div class="m-3">-->
      <!--                <a href="#" class="text-right float-right" data-toggle="sidebar-right" data-target=".sidebar-right">-->
      <!--                    <i class="fe fe-x"></i>-->
      <!--                </a>-->
      <!--            </div>-->
      <!--        </div>-->
    </div>

    <!-- Back to top -->
    <a href="#top" id="back-to-top"><i class="fa fa-long-arrow-up"></i></a>
  </div>
</template>

<script>

import currency from '../currency';
import CardCount from './CardCount'
import CardOrder from './CardOrder'
import axios from 'axios'
import {filter, countBy, map} from 'lodash'
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    CardOrder,
    CardCount
  },
  data () {
    return {
      loading: false,
      local: null,
      counts: [],
      orders: [],
    };
  },
  created () {
    this.update();
    this.counts.push({
      classes: "bg-emaberto",
      icon: "fa-cart-plus",
      label: "PEDIDOS EM ABERTO",
      total: 0,
      description: "Pedidos aguardando confirmação hoje",
    });
    this.counts.push({
      classes: "bg-emseparacao",
      icon: "fa-history",
      label: "PEDIDOS EM SEPARAÇÃO",
      total: 0,
      description: "Pedidos sendo separados pela equipe",
    });
    this.counts.push({
      classes: "bg-entregue",
      icon: "fa-check-circle",
      label: "PEDIDOS ENTREGUES",
      total: 0,
      description: "Pedidos entregues hoje",
    });
    this.counts.push({
      classes: "bg-cancelados",
      icon: "fa-minus-circle",
      label: "PEDIDOS CANCELADOS",
      total: 0,
      description: "Pedidos cancelados hoje",
    });
  },
  mounted () {
    setInterval(this.update, 60000);
    // setTimeout(carregar, 10000);
    //
    // function carregar () {
    //   $('#aparecerteste').show();
    //   new Audio('alerta2.mp3').play();
    // }
    //
    // setTimeout(carregar2, 20000);
    //
    // function carregar2 () {
    //   $('#aparecerteste2').show();
    //   new Audio('alerta2.mp3').play();
    // }
  },
  methods: {
    currency(...p) {
      return currency(...p);
    },
    update() {
      this.loading = true;
      axios.get('http://app.conquistasupermercados.com.br:8083/wsapp/painel_pedidos.php')
        .then((response) => {
          this.loading = false;
          let data = filter(response.data, item => (item.pedido && item.status && item.pedido.length > 0 && item.status.length > 0));

          if (this.$route.params.unidadeId !== undefined && parseInt(this.$route.params.unidadeId, 10) > 0) {
            data = filter(data, item => item.pedido[0].filial === this.$route.params.unidadeId);
            this.local = `${data[0].pedido[0].filial} - ${data[0].pedido[0].nome_loja}`;
          }
          this.updateCounts(data);

          const data2 = filter(data, item => !(item.status !== null && item.status.length !== 0 && item.status[0].seq === '07'));
          this.updateEntries(data2);
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    updateCounts (data) {
      this.counts[0].total = countBy(data, item => {
        return item.status === null || item.status.length === 0 || item.status[0].seq === '01';
      }).true || 0;
      this.counts[1].total = countBy(data, item => {
        return item.status !== null && item.status.length !== 0 && item.status[0].seq === '02';
      }).true || 0;
      this.counts[2].total = countBy(data, item => {
        return item.status !== null && item.status.length !== 0 && item.status[0].seq === '07';
      }).true || 0;
      this.counts[3].total = countBy(data, item => {
        return item.status !== null && item.status.length !== 0 && item.status[0].seq === '99';
      }).true || 0;
    },
    updateEntries (data) {
      let orders = filter(data, item => (item.pedido && item.status && item.pedido.length > 0 && item.status.length > 0 && item.status[0].seq !== '99'));
      orders = map(orders, item => {
        const containerClass = this.getNotificationClass(item.status);
        item.classes = this.getStatusClass(item.status);
        item.containerClass = containerClass;
        item.pulse = containerClass !== '';
        return item;
      });
      this.orders = orders;
    },
    getStatusClass (data) {
      if (data === null || data.length === 0) {
        return '';
      }

      if (data[0].seq === '01') {
        return 'card-emaberto';
      }

      if (data[0].seq === '02') {
        return 'card-emseparacao';
      }

      return '';
    },
    getNotificationClass (data) {
      if (data === null || data.length === 0) {
        return '';
      }

      const date = moment(`${data[0].data} ${data[0].hora}`, 'DD/MM/YYYY HH.mm');

      return date.add(30, 'minute') < moment() ? 'tremer' : '';
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main.vue